module.exports = __webpack_public_path__ + "img/logo-header.d663e808.png";